import type { FilesHttpGetTranscodersQueryPatched } from '@iconik-io/iconik-api/src/schema_patched/files_transcoders';
import { httpGetTranscoders } from '@iconik-io/iconik-api/src/services/files';

import { useAppDispatch } from '../../../../store/react_redux_typed';
import { prepareQueryParameter } from '../../../../utils/search_utils/search_utils';
import {
  type LoadOptionsResult,
  resolveRemoteResponse,
} from '../../../select_field/utils';
import SelectFieldWrapper, {
  type SelectFieldWrapperProps,
} from '../select/select';
import SelectFieldMultiWrapper, {
  type SelectFieldMultiWrapperProps,
} from '../select_multi/select_multi';

type SingleProps = SelectFieldWrapperProps & {
  isMulti?: false;
};

type MultiPlainProps = SelectFieldMultiWrapperProps & {
  isMulti: true;
  plainMultiValues: true;
};

type Props = (SingleProps | MultiPlainProps) & {
  isLocal?: boolean;
  transcoderType?: string;
};

export const SelectTranscodersFieldWrapper = (props: Props) => {
  const dispatch = useAppDispatch();

  const handleLoadOptions = (query: string): Promise<LoadOptionsResult> => {
    const transcodersQuery: FilesHttpGetTranscodersQueryPatched = {
      query: prepareQueryParameter(query),
      per_page: 100,
      'settings.local':
        props.isLocal !== undefined ? String(props.isLocal) : undefined,
      type:
        props.transcoderType !== undefined ? props.transcoderType : undefined,
    };

    return dispatch(httpGetTranscoders(transcodersQuery)).then(
      resolveRemoteResponse((response) =>
        response.body.objects.map((object) => ({
          value: object.id,
          label: object.name,
        })),
      ),
    );
  };

  const sharedProps = {
    preloadOptions: true,
    loadOptions: handleLoadOptions,
  };

  if (props.isMulti) {
    return <SelectFieldMultiWrapper {...props} {...sharedProps} />;
  }

  return <SelectFieldWrapper {...props} {...sharedProps} />;
};
